export const PAGE_POSITION_KEYS = ['filed_index', 'hall_index']

export const removeAllPagePositions = () => {
    // PAGE_POSITION_KEYS.forEach((key) => {
    //     localStorage.removeItem(key)
    // })
}
